import { Component, OnDestroy } from '@angular/core';
import { EmailValidator } from '@angular/forms';

import { MessageService } from '@src/app/shared/services/message.service';
import { AnalyticsService } from '@src/app/shared/services/fb-analytics.service';
import { submitState } from '@src/app/shared/animations/animations';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-newsletter-banner',
  templateUrl: './newsletter-banner.component.html',
  styleUrls: ['./newsletter-banner.component.scss'],
  animations: [
    submitState
  ]
})
export class NewsletterBannerComponent implements OnDestroy {
  email: EmailValidator;
  addUserSub: Subscription;

  submitState: boolean = false;
  successState: boolean = false;
  failureState: boolean = false;
  
  constructor(
    private analyticsService: AnalyticsService,
    private messageServive: MessageService
  ) { }

  subscribe($event?: Event) { 
    if($event)
      this.analyticsService.trackInput($event);

    this.submitState = true;

    this.addUserSub = this.messageServive.subscribeUser(this.email).subscribe(d => {
      this.submitState = false;

      if (d.error) 
        return this.failureState = true;
      
      this.successState = true;
    })
  }

  getSubmitMsg(): string {
    if (this.submitState)
      return 'Sending&hellip;';

    if (this.successState) 
      return `You have successfully subscribed! <br /><br /> Email address: <strong>${ this.email }</strong> <br /><br /> You will eventually be sent a welcome email so please check your inbox. 😊`;

    if (this.failureState)
      return 'Sorry, something went wrong. Please retry with a valid email address or try again later.';
  }

  closeConf($event?: Event): void {
    if ($event)
      this.analyticsService.trackInput($event);

		if (this.submitState)
			this.submitState = false;

    if (this.successState) {
      this.successState = false;
      this.email = null;
    }

		if (this.failureState)
			this.failureState = false;
  }

  // Lifecycle Hooks

  ngOnDestroy(): void {
    // this.recaptchaSub.unsubscribe();
    this.addUserSub?.unsubscribe();
  }
}